import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { clearPendingOrder } from "../lib/orderStorage";
import { reportError } from "../lib/reportError";

export const usePaymentStatus = sessionId => {
  const [status, setStatus] = useState("confirming");
  const [error, setError] = useState("");
  useEffect(() => {
    setStatus(sessionId ? "confirming" : "unknown");
    setError("");
    if (!sessionId) return;
    const controller = new AbortController();
    let timer;
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${encodeURIComponent(sessionId)}`, { signal: controller.signal, timeout: 10000 });
        if (controller.signal.aborted) return;
        setError("");
        if (data.payment_status === "paid") {
          clearPendingOrder();
          setStatus("paid");
          return;
        }
      } catch (error) {
        if (controller.signal.aborted) return;
        reportError("Payment status could not be checked", error);
        setError("Payment verification is temporarily unavailable. We are retrying.");
      }
      if (controller.signal.aborted) return;
      if (attempts >= 24) { setStatus("unknown"); setError(""); return; }
      timer = setTimeout(poll, 2500);
    };
    // A StrictMode setup/cleanup replay must not dispatch a cancelled first poll.
    timer = setTimeout(poll, 0);
    return () => { controller.abort(); clearTimeout(timer); };
  }, [sessionId]);
  return { status, error };
};